// Mock data for MYLKSYSTEMS portfolio website

export const companyInfo = {
  name: "MYLKSYSTEMS",
  tagline: "Innovative Software Solutions for Modern Business",
  description: "Leading software development company in Sri Lanka, specializing in custom web applications, mobile development, and enterprise solutions.",
  established: "2023",
  location: "Colombo, Sri Lanka",
  email: "info@mylksystems.lk",
  // phone: "+94 11 234 5678",
  address: "Colombo, Sri Lanka"
};

export const services = [
  {
    id: 1,
    title: "Web Application Development",
    description: "Custom web applications built with modern frameworks like React, Angular, and Vue.js for scalable business solutions.",
    icon: "Code",
    features: ["React/Angular/Vue.js", "Node.js Backend", "Cloud Deployment", "Responsive Design"]
  },
  {
    id: 2,
    title: "Mobile App Development", 
    description: "Native and cross-platform mobile applications for iOS and Android using React Native and Flutter.",
    icon: "Smartphone",
    features: ["React Native", "Flutter", "Native iOS/Android", "App Store Deployment"]
  },
  {
    id: 3,
    title: "Enterprise Software Solutions",
    description: "Robust enterprise systems including ERP, CRM, and custom business management solutions.",
    icon: "Building2",
    features: ["ERP Systems", "CRM Solutions", "Database Design", "System Integration"]
  },
  {
    id: 4,
    title: "E-commerce Development",
    description: "Complete e-commerce platforms with payment integration, inventory management, and analytics.",
    icon: "ShoppingCart",
    features: ["Online Stores", "Payment Gateway", "Inventory Management", "Analytics Dashboard"]
  },
  {
    id: 5,
    title: "UI/UX Design",
    description: "User-centered design approach creating intuitive interfaces and seamless user experiences.",
    icon: "Palette",
    features: ["User Research", "Wireframing", "Prototyping", "Design Systems"]
  },
  {
    id: 6,
    title: "Cloud Solutions",
    description: "Cloud migration, deployment, and management services using AWS, Azure, and Google Cloud.",
    icon: "Cloud",
    features: ["AWS/Azure/GCP", "DevOps", "CI/CD Pipelines", "Cloud Migration"]
  }
];

export const projects = [
  {
    id: 1,
    title: "FinanceFlow ERP",
    description: "Comprehensive ERP system for financial institutions with real-time reporting and multi-branch management.",
    category: "Enterprise Software",
    technologies: ["React", "Node.js", "PostgreSQL", "AWS"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
    status: "Completed",
    duration: "8 months",
    teamSize: "6 developers"
  },
  {
    id: 2,
    title: "MediCare Mobile App",
    description: "Healthcare management app connecting patients with doctors, appointment booking, and prescription management.",
    category: "Mobile Development",
    technologies: ["React Native", "Firebase", "Node.js", "MongoDB"],
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=600&h=400&fit=crop",
    status: "Completed",
    duration: "6 months",
    teamSize: "4 developers"
  },
  {
    id: 3,
    title: "RetailHub E-commerce",
    description: "Multi-vendor e-commerce platform with advanced analytics, inventory management, and payment integration.",
    category: "E-commerce",
    technologies: ["Next.js", "Express.js", "MySQL", "Stripe API"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop",
    status: "In Progress",
    duration: "10 months",
    teamSize: "8 developers"
  },
  {
    id: 4,
    title: "EduTech Learning Platform",
    description: "Online learning management system with video streaming, assessments, and progress tracking.",
    category: "Web Application",
    technologies: ["Vue.js", "Laravel", "MySQL", "WebRTC"],
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=400&fit=crop",
    status: "Completed",
    duration: "7 months",
    teamSize: "5 developers"
  },
  {
    id: 5,
    title: "LogiTrack Supply Chain",
    description: "Supply chain management system with real-time tracking, inventory optimization, and analytics dashboard.",
    category: "Enterprise Software",
    technologies: ["Angular", "Spring Boot", "Oracle DB", "Docker"],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop",
    status: "Completed", 
    duration: "9 months",
    teamSize: "7 developers"
  },
  {
    id: 6,
    title: "TourismLK Mobile App",
    description: "Tourism mobile app showcasing Sri Lankan destinations with AR features and booking integration.",
    category: "Mobile Development",
    technologies: ["Flutter", "Firebase", "AR Core", "Google Maps API"],
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
    status: "Completed",
    duration: "5 months", 
    teamSize: "4 developers"
  }
];

export const team = [
  {
    id: 1,
    name: "Arjuna Perera",
    position: "CEO & Lead Developer",
    description: "Full-stack developer with 12+ years experience in enterprise software development and team leadership.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
    skills: ["Leadership", "Full-Stack Development", "System Architecture", "Project Management"],
    experience: "12+ years"
  },
  {
    id: 2,
    name: "Sanduni Fernando",
    position: "CTO & Senior Developer",
    description: "Technology strategist specializing in modern web frameworks and cloud architecture solutions.",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop",
    skills: ["React/Angular", "Cloud Architecture", "DevOps", "Technical Strategy"],
    experience: "10+ years"
  },
  {
    id: 3,
    name: "Kasun Rodrigo",
    position: "Senior Mobile Developer",
    description: "Mobile development expert with extensive experience in React Native and Flutter applications.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
    skills: ["React Native", "Flutter", "iOS Development", "Android Development"],
    experience: "8+ years"
  },
  {
    id: 4,
    name: "Thilini Silva",
    position: "UI/UX Designer",
    description: "Creative designer focused on user experience and modern interface design for web and mobile applications.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop",
    skills: ["UI/UX Design", "Figma", "User Research", "Design Systems"],
    experience: "6+ years"
  },
  {
    id: 5,
    name: "Nuwan Jayasuriya",
    position: "Backend Developer",
    description: "Backend specialist with expertise in scalable server architecture and database optimization.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop",
    skills: ["Node.js", "Python", "Database Design", "API Development"],
    experience: "7+ years"
  },
  {
    id: 6,
    name: "Chamika Rathnayake",
    position: "DevOps Engineer",
    description: "DevOps expert ensuring smooth deployment and infrastructure management for all projects.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop",
    skills: ["AWS/Azure", "Docker", "Kubernetes", "CI/CD Pipelines"],
    experience: "5+ years"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajith Wijesinghe",
    position: "CEO, Lanka Finance Ltd",
    company: "Lanka Finance Ltd",
    content: "MYLKSYSTEMS delivered an exceptional ERP solution that transformed our operations. Their technical expertise and attention to detail exceeded our expectations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Dr. Priya Gunasekara",
    position: "Director, MediCare Hospital",
    company: "MediCare Hospital",
    content: "The healthcare app developed by MYLKSYSTEMS has significantly improved patient engagement and streamlined our appointment system. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "Sampath Bandara",
    position: "Founder, RetailHub",
    company: "RetailHub",
    content: "Working with MYLKSYSTEMS on our e-commerce platform was a fantastic experience. They delivered a robust, scalable solution on time and within budget.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
  }
];

export const technologies = [
  { name: "React", category: "Frontend" },
  { name: "Angular", category: "Frontend" },
  { name: "Vue.js", category: "Frontend" },
  { name: "Node.js", category: "Backend" },
  { name: "Python", category: "Backend" },
  { name: "Laravel", category: "Backend" },
  { name: "React Native", category: "Mobile" },
  { name: "Flutter", category: "Mobile" },
  { name: "MongoDB", category: "Database" },
  { name: "PostgreSQL", category: "Database" },
  { name: "MySQL", category: "Database" },
  { name: "AWS", category: "Cloud" },
  { name: "Azure", category: "Cloud" },
  { name: "Docker", category: "DevOps" },
  { name: "Kubernetes", category: "DevOps" }
];

export const stats = [
  { label: "Projects Completed", value: "34+" },
  { label: "Happy Clients", value: "35+" },
  { label: "Years Experience", value: "3+" },
  { label: "Team Members", value: "5+" }
];